import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

export const AssetInfoWrapper = styled('section')<{ theme?: TTheme }>`
    display: flex;
    flex-direction: column;
    gap: 24px;
`
